<template>
   <div class="g-radio-button-container" :class="[nativeValue == value ? 'checked' : '', color ? `color-${color}` : '']" @click="handlerInput">
      <span class="g-radio-check"></span>
      <input type="radio" :name="name" :id="id" :value="nativeValue" />
      <label :for="id">{{ label }}</label>
   </div>
</template>

<script>
export default {
   name: "UIRadioButton",
   props: {
      label: String,
      id: String,
      name: String,
      value: [String, Number],
      nativeValue: [String, Number],
      color: String, // 'primary' or default
   },
   methods: {
      handlerInput() {
         const self = this;
         self.$emit("input", self.nativeValue);
      },
   },
};
</script>

<style lang="scss" scoped>
.g-radio-button-container {
   display: flex;
   align-items: center;
   cursor: pointer;

   label {
      cursor: pointer;
      margin-left: 0.5rem;
      font-weight: 400;
   }

   .g-radio-check {
      width: 1.4rem;
      height: 1.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid var(--gray-700-light);
      border-radius: 50%;
      position: relative;
      flex-shrink: 0;
   }

   input {
      position: absolute;
      left: 0;
      opacity: 0;
      outline: 0;
      z-index: -1;
   }

   &.checked {
      label {
      }
      .g-radio-check {
         border: 2px solid var(--accent-primary) !important;
         background: var(--accent-primary);
         outline: 0.25rem solid var(--accent-primary-lighter);

         &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            background: var(--accent-primary);
            background: var(--gray-50);
            width: 0.52rem;
            height: 0.52rem;
            border-radius: 50%;
         }
      }
   }

   &.color-primary.checked {
      .g-radio-check {
         border: 2px solid var(--primary) !important;
         background: var(--primary);
         outline: 0.25rem solid rgba(0, 127, 214, 0.15);

         &::before {
            background: var(--gray-50);
         }
      }
   }
}
</style>
